import { useLanguage } from '../../languages/language'
import { Container } from '../../styles/global'
import {
  HomeContainer,
  LeftContainer,
  RightContainer,
  Frame,
  Skill,
  PortraitContainer,
} from './styled'
import { IconLinkedIn, IconEmail } from '../../icons/sociallogos'
import {
  IconHTML,
  IconCSS,
  IconJavaScript,
  IconTypeScript,
  IconGithub,
  IconVercel,
  IconReact,
  IconNextJS,
  IconPostgreSQL,
  IconSvelte,
  IconPhotoshop,
  IconIllustrator,
  IconAfterEffects,
  IconFigma,
  IconAffinity,
  IconCinema4D,
  IconBlender,
  IconTailwind,
  IconStyledComponents,
} from '../../icons/otherIcons'
const Home = () => {
  const { texts } = useLanguage()
  return (
    <Container>
      <HomeContainer>
        <LeftContainer>
          <h2>{texts.introduction[0]}</h2>
          <PortraitContainer>
            <img alt="portrait" src="images/darkportrait_s.jpg" />
          </PortraitContainer>
          <p>{texts.introduction[1]}</p>
          <p>{texts.introduction[2]}</p>
          <p>{texts.introduction[3]}</p>
          <p>{texts.introduction[4]}</p>
          <a
            title="LinkedIn"
            href="https://www.linkedin.com/in/jakub-sirotek-1bb0364a/"
            rel="noreferrer noopener"
            target="_blank"
          >
            <IconLinkedIn />
          </a>
          <a title="Email" href="mailto:sirotek.j@gmail.com">
            <IconEmail />
          </a>
        </LeftContainer>

        <RightContainer>
          <h3>{texts.skills[0]}</h3>
          <Frame className="columns">
            <div>
              <Skill>
                <IconHTML />
                <span>HTML</span>
              </Skill>
              <Skill>
                <IconCSS />
                <span>CSS, Sass</span>
              </Skill>
              <Skill>
                <IconJavaScript />
                <span>JavaScript</span>
              </Skill>
              <Skill>
                <IconTypeScript />
                <span>Typescript</span>
              </Skill>
              <Skill>
                <IconGithub />
                <span>Github</span>
              </Skill>
              <Skill>
                <IconVercel />
                <span>Vercel</span>
              </Skill>
            </div>
            <div>
              <Skill>
                <IconReact />
                <span>React</span>
              </Skill>
              <Skill>
                <IconNextJS />
                <span>NextJS</span>
              </Skill>
              <Skill>
                <IconTailwind />
                <span>Tailwind</span>
              </Skill>
              <Skill>
                <IconStyledComponents />
                <span>Styled Components</span>
              </Skill>
              <Skill>
                <IconPostgreSQL />
                <span>PostgreSQL</span>
              </Skill>
              <Skill>
                <IconSvelte />
                <span>Svelte</span>
              </Skill>
            </div>
          </Frame>
          <h3>{texts.skills[1]}</h3>
          <Frame className="columns">
            <div>
              <Skill>
                <IconPhotoshop />
                <span>Photoshop</span>
              </Skill>
              <Skill>
                <IconIllustrator />
                <span>Illustrator</span>
              </Skill>
            </div>
            <div>
              <Skill>
                <IconFigma />
                <span>Figma</span>
              </Skill>
              <Skill>
                <IconAffinity />
                <span>Affinity</span>
              </Skill>
            </div>
          </Frame>
          <h3>{texts.skills[2]}</h3>
          <Frame className="columns">
            <div>
              <Skill>
                <IconCinema4D />
                <span>Cinema 4D</span>
              </Skill>
              <Skill>
                <IconBlender />
                <span>Blender</span>
              </Skill>
            </div>
            <div>
              <Skill>
                <IconAfterEffects />
                <span>After Effects</span>
              </Skill>
            </div>
          </Frame>

          {/*<h3>{texts.skills[3]}</h3>
          <Frame className="columns">
            <div></div>
            <div>
              
            </div>
          </Frame>*/}
        </RightContainer>
      </HomeContainer>
    </Container>
  )
}
export default Home
